'use strict';

import store from 'store';
import moment from 'moment';
import cookie from 'cookie-monster';

import { getTestGroup } from './ABTest';

const _env = {
};

export function  getConfig(key) {
    return _env[key];
}

export function  setConfig(key, value) {
    _env[key] = value;

    return value;
}

/**
 * The consumer homepage, the /pro* pages and the blog now live on the Webflow
 * marketing site, so their in-app counterparts are retired: anything that would
 * land on one hands off to Webflow instead, preserving the path and query so
 * /pro/medical and /blog/nutrition-101 arrive at their marketing-site counterparts.
 *
 * The native app keeps rendering them — it has no browser to hand off to, the
 * logged-out consumer homepage is its login entry point, and replacing the
 * webview's location would strand the user outside the app.
 *
 * An empty marketing_site_host disables the hand-off entirely, so an environment
 * with no marketing site of its own (localdev) renders the in-app pages instead
 * of bouncing out to somebody else's.
 *
 * @param {Location} location - anything with pathname/search (a router location
 *                              or window.location)
 * @returns {boolean} whether the hand-off was made
 */
export function redirectToMarketingSite(location = window.location) {
    if (window.cordova) {
        return false;
    }

    const marketingSiteHost = getConfig('marketing_site_host');

    if (!marketingSiteHost) {
        return false;
    }

    const { pathname, search } = location;

    window.location.replace('https://' + marketingSiteHost + pathname + (search || ''));

    return true;
}

export function  cleanupLocalStorage() {

    // Remove old entries
    // ------------------
    // dashboard-featured-plans2-*
    // user-store-preferences
    //
    //
    // Keep most recent 25
    // --------------------
    // patient-recommended-plans-
    // menu-edited-
    //
    //
    // Add Expirations
    // ---------------
    // recent-edits

    let keysToRemove = [], edited = [], recommended = [];

    // ensure expired records are gone
    store.each((val, key) => {
        let ret = null, exp = null;

        // If the value was expired automatically, we don't need to do anything else.
        if (!(ret = store.get(key))) {
            return;
        }

        // We can ignore our expiration meta. This is part of a plugin, and if we remove
        // their associated key, the meta records also get deleted
        if (key.match(/__storejs_expire_mixin_/)) {
            return;
        }

        // Keys to remove
        if (key.match(/dashboard-featured-plans2-/) ||
            key.match(/user-store-preferences/)) {
            keysToRemove.push(key);
        }

        if (key.match(/patient-recommended-plans-/)) {
            exp = store.get('__storejs_expire_mixin_' + key);
            recommended.push({key, val, exp});
        }

        if (key.match(/menu-edited-/)) {
            exp = store.get('__storejs_expire_mixin_' + key);
            edited.push({key, val, exp});
        }

        // See if there's old A/B test group entries that can be cleaned up.
        // All our current A/B tests will return a value from getTestGroup. Deprecated tests will return undefined.
        var testGroupKey = key.match(/(.*)-test-group/);
        if (testGroupKey) {
            var testGroup = getTestGroup(testGroupKey[1]);
            if (!testGroup) {
                keysToRemove.push(key);
            }
        }
    });

    const sortByExp = (a, b) => {
        if (a.exp < b.exp) return 1;
        if (a.exp > b.exp) return -1;
        return 0;
    }

    recommended.sort(sortByExp);
    edited.sort(sortByExp);

    // Slice off all but the most recent 10 items in each list.
    if (recommended.length > 10) {
        recommended.slice(10 - recommended.length).forEach(rec => keysToRemove.push(rec.key));
    }

    if (edited.length > 10) {
        edited.slice(10 - edited.length).forEach(rec => keysToRemove.push(rec.key));
    }

    keysToRemove.forEach(key => store.remove(key));
}

export function setMref(mref) {
    if (!mref) {
        store.remove('merchant-ref');
        cookie.setItem('merchant-ref', null);
        return;
    }

    store.set('merchant-ref', mref);
    cookie.setItem('merchant-ref', mref, {
        expires: moment().add(10, 'years').toDate().toUTCString(),
        domain: getConfig('www_host').replace('www.', '.'),
        path: '/',
        secure: true,
    });
}

export function getMref() {
    const inStore = store.get('merchant-ref');
    const inCookie = cookie.getItem('merchant-ref');

    return inStore || inCookie;
}

export function isProSide() {
    return window.location.hostname.startsWith('pro.');
}
